import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { CommonButton } from '../../../../components/buttons';
import { renderAutoCompleteSingleSelect, renderTextField } from '../../../../components/reduxFields';

import SignaturePad from 'react-signature-pad';
import { ABCSPECTRUM } from '../../../../actions/utilAction';

const requireEmployee = (value) => !value || !Number.isInteger(value) ? 'Please select employee' : null;
const requireGuardian = (value) => !value ? 'Please enter guardian name' : null;
const requireRenderingProvider = (value) => !value ? 'Please enter supervising clinician name' : null;
//const requireRenderingProvider = (value) => !value || !Number.isInteger(value) ? 'Please select supervising clinician' : null;

const validate = (values) => {
  let error = {};
  if (!values.Signee || !Number.isInteger(values.Signee)) {
    error.Signee = 'Please select signee';
  }
  return error;
};

class SignatureModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      clear: false,
      isLoading: false,
      signee: [],
      signeeId: null,
    };
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.resetClear = this.resetClear.bind(this);
    this.handleSigneeChange = this.handleSigneeChange.bind(this);
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.closeDialog();
  };

  handleClear = () => {
    var signature = this.refs.mySignature;

    signature.clear();
  }

  // componentDidMount() {
  //   this.resizeCanvas();
  // }

  componentWillReceiveProps(nextProps) {

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  // resizeCanvas() {
  //   var canvas = this.refs.mySignature;
  //   var ratio = Math.max(window.devicePixelRatio || 1, 1);
  //   canvas.width = canvas.offsetWidth * ratio;
  //   canvas.height = canvas.offsetHeight * ratio;
  //   // canvas.getContext('2d').scale(ratio, ratio);
  //   // signaturePad.clear(); // otherwise isEmpty() might return incorrect value
  // }


  resetClear(evt) {
    this.setState({ clear: false });
  }

  handleSigneeChange(input, selectedValue) {
    input.onChange(selectedValue.value);
    this.setState({ signeeId: selectedValue.value });
  }

  onSubmitHandler = (formProps) => {
    var signature = this.refs.mySignature;
    if (signature.isEmpty()) {
      return false;
    }

    this.setState({ isLoading: true });
    let self = this;
    var imageBytes = signature.toDataURL(); // toDataURL generates base64 bytes as png image.
    formProps.signBytes = imageBytes;
    self.setState({ isLoading: false });
    self.props.handleAddSign(formProps);
    self.handleClose();
  }

  renderFields = () => {
    switch (this.state.signeeId) {
    case 1:
      return (
        <div className="col-sm-6 require mt-40">
          <Field
            name="StaffID"
            label={this.props.agencyName.toUpperCase() === ABCSPECTRUM ? 'Practitioner' : 'Employee'}
            validate={[requireEmployee]}
            options={this.props.staffsList}
            handleNewRequest={(input, selectedValue) => input.onChange(selectedValue.value)}
            component={renderAutoCompleteSingleSelect}
          />
        </div>);
    case 2:
      return (
        <div className="col-sm-6">
          <Field
            name="Client"
            label="Client"
            type="text"
            disabled={true}
            component={renderTextField}
          />
        </div>);
    case 3:
      return (
        <div className="col-sm-6 require">
          <Field
            name="Guardian"
            type="text"
            label="Guardian"
            maxLength={20}
            validate={[requireGuardian]}
            component={renderTextField}
          />
        </div>);
     case 4:
      return (
        <div className="col-sm-6 require">
          {/* <Field
            name="RenderingProviderID"
            label="Supervising Clinician"
            validate={[requireRenderingProvider]}
            options={this.props.renderingProvidersList}
            handleNewRequest={(input, selectedValue) => input.onChange(selectedValue.value)}
            component={renderAutoCompleteSingleSelect}
          /> */}
          <Field
            name="SupervisingClinician"
            type="text"
            label="Supervising Clinician"
            maxLength={50}
            validate={[requireRenderingProvider]}
            component={renderTextField}
          />
        </div>);
    default:
      return <div className="col-sm-6">&nbsp;</div>;

    }
  }

  render() {
    const { handleSubmit } = this.props;
    const actions = [
      <CommonButton label="Cancel" className="mr-15 grey_btn" onTouchTap={this.handleClose}/>,
      <CommonButton label= "Clear" primary={true} className="mr-15" onTouchTap={this.handleClear}/>,
      <CommonButton type="submit" primary={true} label= "Done" onTouchTap={handleSubmit(this.onSubmitHandler)}/>,
    ];
    return (
      <div>
        {this.state.open ?
          <Dialog className="custom_modal"
            title={'Add Signature'}
            modal={false}
            open={this.state.open}
            actions={actions}
            repositionOnUpdate={false}
            autoScrollBodyContent={true}
          >
            <div className="row">
              <div className="col-sm-12">
                <form className="readmin-form custom_form">
                  <div className="row">
                    <div className="col-sm-6 require mt-40">
                      <Field
                        name="Signee"
                        label="Signee"
                        options={this.props.signeeList}
                        handleNewRequest={this.handleSigneeChange}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>

                    {this.renderFields()}
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div id="signCanvas">
                        <SignaturePad ref="mySignature"/>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Dialog> : null}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let loginUser = state.login.loginUserInfo;
  // console.log('ownProps.staffs....', ownProps.staffs, loginUser, ownProps.staffID)
  let staffs = ownProps.staffs.filter((Obj) => { // filter the staffs list - login staff and practitioner ...
    if (Obj.id === loginUser.id || Obj.id === ownProps.staffID) {
      return Obj;
    } else {
      return null;
    }
  });

  let signeeList = [];
  if (state.appConfig.appConfigList && state.appConfig.appConfigList.data) {
    let app_config = state.appConfig.appConfigList.data;
    if (app_config && app_config.length) {
      app_config.forEach((Obj) => {
        if (Obj.configType === 1) {
          switch (Obj.key) {
          case 'CLINICIAN_SIGN':
            signeeList.push({ id: 1, value: 'Employee' });
            break;
          case 'PATIENT_SIGN':
            signeeList.push({ id: 2, value: 'Client' });
            break;
          case 'GUARDIAN_SIGN':
            signeeList.push({ id: 3, value: 'Guardian' });
            break;
          case 'RENDERINGPROVIDER_SIGN':
            signeeList.push({ id: 4, value: 'Supervising Clinician' });
            break;
          default:
            break;
          }
        }
      });
    }
  }

  return {
    loading: state.patient.loading,
    signeeList: signeeList,
    staffsList: staffs,
    renderingProvidersList: ownProps.renderingProviders,
    initialValues: { StaffID: ownProps.staffID, Client: ownProps.clientName, RenderingProviderID: ownProps.renderingProviderID },
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
};

SignatureModal = reduxForm({
  form: 'SignatureModal',
  validate,
})(SignatureModal);

export default connect(mapStateToProps, null)(SignatureModal);



// WEBPACK FOOTER //
// ./src/modules/scheduling/components/soap/signatureWithRenderingProvider_modal.js